module.exports = __webpack_public_path__ + "static/media/dsp-logo.64e355d0.svg";